import { render, staticRenderFns } from "./AttachingFile.vue?vue&type=template&id=2aa590aa&scoped=true"
import script from "./AttachingFile.vue?vue&type=script&lang=ts"
export * from "./AttachingFile.vue?vue&type=script&lang=ts"
import style0 from "./AttachingFile.vue?vue&type=style&index=0&id=2aa590aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa590aa",
  null
  
)

export default component.exports